module.exports = __webpack_public_path__ + "img/chope.e5b943d7.svg";